export const getImageUrl = (imgPath) => {
  const finalUrl = imgPath?.startsWith("http")
    ? imgPath
    : `${process.env.REACT_APP_IMAGE_PATH}/${imgPath}`;

  console.log("===== IMAGE URL DEBUG =====");
  console.log("Input image path:", imgPath);
  console.log("REACT_APP_IMAGE_PATH:", process.env.REACT_APP_IMAGE_PATH);
  console.log("Final image URL:", finalUrl);
  console.log("===========================");

  return finalUrl;
};